import { cva } from "../cva.ts"

export const TextboxAffix = ({
  children,
  text,
  type = "prefix",
  className,
}: TextboxAffix.Props) => {
  return (
    <span className={classForRoot({ type, className })} role="group">
      <Affix type={type}>{text}</Affix>
      {children}
    </span>
  )
}

const classForRoot = cva(["inline-flex [&>:last-child:not(:only-child)]:z-10"], {
  variants: {
    type: {
      prefix: "flex-row [&>:last-child:not(:only-child)]:rounded-l-none",
      suffix: "flex-row-reverse [&>:last-child:not(:only-child)]:rounded-r-none",
    },
  },
})

const Affix = ({ children, type }: Affix.Props) => {
  return <span className={classForAffix({ type })}>{children}</span>
}

const classForAffix = cva(
  ["select-none py-2 px-3 flex items-center text-sm text-gray-11 bg-gray-2 bshadow-gray-4"],
  {
    variants: {
      type: {
        prefix: "bshadow-tbl rounded-l-sm",
        suffix: "bshadow-tbr rounded-r-sm",
      },
    },
  },
)

export namespace TextboxAffix {
  export type Props = {
    type: "prefix" | "suffix"
    text: string
    children: React.ReactNode
    className?: string
  }
}

namespace Affix {
  export type Props = {
    children: React.ReactNode
    type: "prefix" | "suffix"
  }
}
